import { useQuery } from "@tanstack/react-query";
import { getWhatsappAnalytics } from "api/bMarketingApi";

const EMPTY_WHATSAPP_ANALYTICS = {
  summary: {
    sent: 0,
    delivered: 0,
    read: 0,
    failed: 0,
    delivery_rate: 0,
    read_rate: 0,
    failure_rate: 0,
  },
  daily_activity: [],
  top_templates: [],
  sender_numbers: [],
  unique_recipients: 0,
  messaging_limits: {
    accounts: [],
    total_limit: null,
    total_used: 0,
    total_remaining: null,
    window_hours: 24,
  },
};

export function useWhatsappAnalytics(organisationId) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["whatsappAnalytics", organisationId],
    queryFn: () => getWhatsappAnalytics(organisationId).then((res) => res.data),
    enabled: !!organisationId,
    refetchInterval: 30000,
  });

  return {
    analytics: data || EMPTY_WHATSAPP_ANALYTICS,
    isLoading,
    error,
    refetch,
  };
}
